export default "__VITE_ASSET__DIjpm9Qo__"